import { LoaderCircle } from 'lucide-react';
import { useSiteAccess } from '@/features/auth/use-auth';
import { useBrand } from '@/features/branding/brand-provider';
import { TemplatesList } from '@/features/site-templates/templates-list';
import { NotFound } from '@/routes/not-found';

// Ports app/[brand]/admin/templates/page.tsx: the site-templates section is
// super-admin only (the Next header exposed it only inside the super-admin nav
// group). Renders content inside the admin Shell.
export function Templates() {
  const { slug, loading } = useBrand();
  const { access, loading: roleLoading } = useSiteAccess(slug);

  if (loading || roleLoading) {
    return (
      <div className="flex items-center justify-center py-12">
        <LoaderCircle className="text-primary size-8 animate-spin" />
      </div>
    );
  }

  if (!access?.superAdmin) {
    return <NotFound />;
  }

  return <TemplatesList />;
}
